import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import SF36Form from './SF36Form.js'

//New survey img
import new_survey_button from '../../Images/Healthform/New_survey.png';

class SF36Display extends Component {

    constructor(props) {
        super(props);

        this.state = {
            displaySF36FormPopup: false
        };

    }

    togglePopup = () => {
        this.setState(
            { displaySF36FormPopup: !this.state.displaySF36FormPopup }
        )
    }

    //Display render
    render(){
        return (
            <div style={{ flex:1, flexDirection:'column', alignItems:'center', justifyContent:'center', paddingTop:"30%"}}>

                    {this.props.accountInformation.readOnly === true ?
                        null
                        :
                    <button onClick={this.togglePopup} style={{backgroundColor:"transparent"}}>
                        <img src={new_survey_button} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "35px"}} alt="new_survey_logo"/>
                    </button>
                    }
                    {this.state.displaySF36FormPopup ?
                        <SF36Form
                            cancelPopup={this.togglePopup}
                            id_patient={this.props.id_patient}
                            update={this.props.update}
                            BannerDisplayedAlerts={this.state.BannerDisplayedAlerts}
                            screenSize={this.props.screenSize}
                            intl={this.props.intl}
                            accountInformation={this.props.accountInformation}
                        />
                        :
                        null
                    }
            </div>
        );
    }
}
export default (SF36Display);